import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import { backPackEventMap } from "../../config/BackpackEventConfig";
import NormalGameManager from "../../manager/NormalGameManager";
import { getFoodMaterialGiveAry } from "./config/FoodMaterialConfig";

const {ccclass, property} = cc._decorator;

@ccclass
export default class setUpShopGivePage extends cc.Component {

    @property({type:cc.Node,displayName:"item"})
    item:cc.Node = null;

    @property({type:cc.Node,displayName:"itemContent"})
    itemContent:cc.Node = null;

    onLoad(){
        this.loadPage();
    }

    loadPage(){
        let ary = getFoodMaterialGiveAry();
        for(let i of ary){
            let node = cc.instantiate(this.item);
            let nameLb:cc.Label = node.getChildByName("labelName").getComponent(cc.Label);
            let countLb:cc.Label = node.getChildByName("labelCount").getComponent(cc.Label);
            let backConfig = backPackEventMap()[i.id];
            if(backConfig){
                nameLb.string = backConfig.name;
                countLb.string = data_control.getNumberFormat(i.count);
                node.setParent(this.itemContent);
            }else{
                console.log(`错误的物品id${i.id} #setUpShopGivePage`);
            }
        }
    }

    onGive(){
        let ary = getFoodMaterialGiveAry();
        for(let i of ary){
            let backConfig = backPackEventMap()[i.id];
            if(backConfig){
                NormalGameManager._instance.onPushGoods(i.id,i.count);
            }
        }
    }

    onBtnComit(){
        this.onGive();
        this.closeThis();
    }

    onBtnClose(){
        this.onGive();
        this.closeThis();
    }

    closeThis(){
        O1HD.emit("SwingPlateShop.loadItems");
        this.node.destroy();
        this.node.removeFromParent();
    }
    
}
